import axiosService from './axiosService';
import authService from './authService';

class AuditService {
  getAuditFields = () => axiosService.get('/api/audits/fields');

  searchAudit = (data) => axiosService.post('/api/audits/search', data);

  exportAudit = (data) => axiosService.postBlob('/api/audits/export', data);

  saveAuditSearch = (data) => axiosService.post('/api/audits/saved-searches', data);

  getSavedAuditSearches = () => axiosService.get(`/api/audits/saved-searches/users/${authService.getUserId()}`);

  deleteSavedAuditSearch = (searchId) => axiosService.delete(`/api/audits/saved-searches/${searchId}`);
}

const auditService = new AuditService();
export default auditService;
